import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DataTable from "react-data-table-component";
import { ModalBox } from "../Outer/Modal";
import {
  AdminReg,
  AdminGet,
  ManagerGetById,
  AdminGetData,
} from "../../redux/auth-reducer/auth-service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

export const Admin = () => {
  const [searchText, setSearchText] = useState("");
  const [showView, setShowView] = useState(false);
  const [adminDeatils, setAdminDeatils] = useState();
  const [dataSide, setDataSide] = useState();
  const [validated, setValidated] = useState(false);
  const [userData, setUserData] = useState("");
  const [count, setCount] = useState(0);
  const [countryCode, setCountryCode] = useState("");
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [messageEamil, setMessageEamil] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    managerEmailId: "",
    firstName: "",
    lastName: "",
    emailId: "",
    phoneNumber: "",
    password: "",
    adminPassword: "",
    countryCode: null,
  });

  function sidebarfun() {
    setDataSide(!dataSide);
  }

  // const handelPhoneCountryCode = async (e) => {

  //   setCountryCode(e);
  //   setData({
  //     ...data,
  //     countryCode: e,
  //   });
  // };

  useEffect(() => {
    if (data.countryCode) {
      setCountryCode(`+${data.countryCode}`);
    }
  }, [data.countryCode]);

  const handelPhoneCountryCode = async (e) => {
    const newCountryCode = e?.replace("+", "");

    setCountryCode(`+${newCountryCode}`);

    setData((prevForm) => ({
      ...prevForm,

      countryCode: newCountryCode,
    }));
  };
  // const phoneNumber = parsePhoneNumberFromString(
  //   String(data?.phoneNumber),
  //   "US"
  // );
  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
    },
    {
      name: "First Name",
      selector: (row) => row?.firstName,
      sortable: true,
    },
    {
      name: "Last Name",
      selector: (row) => row?.lastName,
      sortable: true,
    },
    {
      name: "Email Address",
      selector: (row) => row?.emailId,
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row?.phoneNumber,
      sortable: true,
    },
    {
      name: "Organization Name",
      selector: (row) => <>{row?.orgName == null ? "-" : row?.orgName}</>,
      sortable: true,
    },
  ];

  const viewFn = (viewItem) => {
    setShowView(true);
  };
  const handleClosed = () => {
    setShowView(false);
    setValidated(false);
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const filteredData = searchText
    ? adminDeatils.filter((item) => {
        return (
          item?.firstName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.lastName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.orgName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.emailId?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : adminDeatils;

  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const userId = isUser?.userId;
  useEffect(() => {
    const UserGet = async () => {
      await ManagerGetById(userId).then((res) => {
        setUserData(res?.data);
      });
    };
    UserGet();
  }, []);

  const handleChange = (e) => {
    const inputValue = e.target.value.slice(0, 30);
    // e.preventDefault();
    // let value = e.target.value;
    // let name = e.target.name;
    // setData((prevalue) => {
    //   return {
    //     ...prevalue,
    //     [name]: value,
    //   };
    // });
    setData({
      ...data,

      [e.target.name]:inputValue,
    });
  };

  const handleSave = async (event) => {
    // event.preventDefault();
    // const form = event.currentTarget;
    // var mailformat = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;



    const form = event.currentTarget.closest('form');
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true); // Show Bootstrap validation feedback
      return; // Stop the function if invalid
    }

    setValidated(true); // Form is valid, set validated to true
    console.log("Form is valid. Submitting data:");


     const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;

    if (!data?.emailId) {
        setMessageEamil("Please enter an email.");
        return;
    }

    if (!data?.emailId.match(mailformat)) {
        setMessageEamil("Email is not valid.");
        return;
    }

    setLoading(true); // Show loader
    setMessageEamil("");




    const dataRegister = [
      {
        // crudOperationId: true,
        id: 0,
        // managerEmailId: userData?.emailId,
        // orgId: userData?.managerId,
        firstName: data?.firstName,
        lastName: data?.lastName,
        emailId: data?.emailId,
        phoneNumber: data?.phoneNumber,
        password: data?.password,
        countryCode: Number(data?.countryCode),
        managerPassword: data?.adminPassword,
      },
    ];

    // if (data?.emailId?.match(mailformat)) {
    //   await AdminReg(dataRegister).then((res) => {
    //     if (res?.data?.status === true) {
    //       toast.success(res?.data?.message);
    //       setCount(count + 1);
    //       setValidated(false);
    //       handleClosed();
    //     } else {
    //       toast.error(res?.data?.message);
    //     }

    //     setData({
    //       managerEmailId: "",
    //       firstName: "",
    //       lastName: "",
    //       emailId: "",
    //       phoneNumber: "",
    //       password: "",
    //       adminPassword: "",
    //     });
    //   });
    // }
     try {
            const res = await AdminReg(dataRegister);
            
            // Hide the loader regardless of success or error response
            setLoading(false);
    
            if (res?.data?.status === true) {
                toast.success(res?.data?.message);
                setCount(count + 1);
                setValidated(false);
                handleClosed();
            } else {
                toast.error(res?.data?.message);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setLoading(false); // Hide the loader if there's an error
            toast.error("An error occurred while submitting the form.");
        }
  };

  const getAdminData = async () => {
    await AdminGet().then((res) => {
      setAdminDeatils(res?.data?.data?.dataList, "res");
    });
  };

  useEffect(() => {
    getAdminData();
  }, [count]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    getAdminData(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };
  const clearSearch = () => {
    setSearchText("");
  };

  return (
    <>
      <ToastContainer></ToastContainer>
      <div className="dasboard-group">
        <TopNavbar sidebarfun={sidebarfun} />
        <Sidebar data={dataSide} />
        <div
          className={
            dataSide ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row className="d-flex align-items-center">
            <Col md={6}>
              <h1 className="heading-dash">Admin</h1>
            </Col>
            <Col md={6} className="text-right">
              <Button
                className="primary button-create-auction btn btn-primary "
                onClick={() => viewFn()}
              >
                <icons.Plus class="icon-plus" /> Add Admin
              </Button>
            </Col>
          </Row>

          <div className="group_data_table admin">
            {/* <div className="search-input d-flex align-items-center">
                <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
            </div> */}
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>

            <div>
              <DataTable
                title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {currentPage} of {totalRows}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={"footer-content"}>
          <Footer />
        </div>
      </div>

      <ModalBox
      show={showView}
      title={<h1 className="heading-dash">Add Admin</h1>}
      body={
        <Form noValidate validated={validated} onSubmit={(e) => e.preventDefault()}> 
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="validationCustom01">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="firstName"
                  value={data.firstName}
                  onChange={handleChange}
                  placeholder="First name"
                  minLength="2" // Example additional HTML validation
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid first name (at least 2 characters).
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="validationCustom02">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="lastName"
                  value={data.lastName}
                  onChange={handleChange}
                  placeholder="Last name"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid last name.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="validationCustomEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  type="email"
                  name="emailId"
                  value={data.emailId}
                  onChange={handleChange}
                  placeholder="Email"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid email.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
             <Col>
                  <Form.Group className="mb-3" controlId="validationCustom01">
                    <Form.Label>Phone Number</Form.Label>
                    <div className="d-flex group-ph">
                      <PhoneInput
                        type="text"
                        international
                        value={countryCode || `+${data?.countryCode}`}
                        onChange={handelPhoneCountryCode}
                        flags={flags}
                        className="phoneAdmin"
                        countryCallingCodeEditable={false}
                      />
                      <PhoneInput
                        type="text"
                        international
                        value={countryCode}
                        onChange={handelPhoneCountryCode}
                        flags={flags}
                        className="phoneCountry"
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                      />
                      <Form.Control
                        required
                        type="number"
                        name="phoneNumber"
                        className="phone-number-input"
                        value={data?.phoneNumber}
                        onChange={(e) => handleChange(e)}
                        placeholder="Phone number"
                      />
                    </div>
                    <Form.Control.Feedback type="invalid">
                      Please enter valid phone number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="validationCustomPassword">
                <Form.Label>Xcutta Password</Form.Label>
                <Form.Control
                  required
                  type="password"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                  placeholder="Password"
                  minLength="8" // Example: minimum 8 characters requirement
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid password (min 8 characters).
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="validationCustomAdminPassword">
                <Form.Label>Temporary Password for Admin</Form.Label>
                <Form.Control
                  required
                  type="password"
                  name="adminPassword"
                  value={data.adminPassword}
                  onChange={handleChange}
                  placeholder="Temporary password"
                  minLength="8"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid temporary password (min 8 characters).
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={12} className="text-right mt-3">
              <Button
                type="button"
                className="btn-Cancel secondary mb-3 me-3"
                onClick={handleClosed}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="btn-Save me-3 mb-3"
                onClick={handleSave} // Calls the validation handler
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      }
    />
    </>
  );
};
